import { createHoldingBookingWeekCancelMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useHoldingBookingWeekCancelMutation = createHoldingBookingWeekCancelMutation(HTTP_CONFIG.API.Consumer.url)
